import { type TFunction, translateFnBuilder } from "src/design-system/core";
import { COMMON_TRANSLATION_NAMESPACE } from "src/i18n/config";
import { setLocale } from "yup";

export function buildYupLocale(_: unknown, t: TFunction): void {
    const currentT = translateFnBuilder(t, `${COMMON_TRANSLATION_NAMESPACE}:`);
    setLocale({
        mixed: {
            required: (field) => {
                return currentT("forms.required", { field: field.path });
            },
        },
        array: {
            min: ({ min }) => currentT("forms.min", { min }),
        },
    });
}
